export const ENVIRONMENT = {
  ANGULAR_APP_API_URL: 'https://api-dev.qmractest.com/',
  ANGULAR_APP_DEFAULT_PLACEHOLDER: '/images/default-placeholder.png',
  ANGULAR_APP_OTP_TIME: 10, //seconds,
  ANGULAR_APP_OTP_TIMER_VALUE: '00:10',
  ANGULAR_APP_DATE_FORMAT: 'DD, MMMM YYYY',
  ANGULAR_APP_DATE_MONTH_FORMAT: 'DD MMMM',
  ANGULAR_APP_DATE_FORMAT_TABLE: 'MMM d, y',
  ANGULAR_APP_SECRET_KEY: 'dev-secret-key-1234567890',

  ANGULAR_APP_USER_ROLE_PERMISSION: {
    admin: {
      dashboard: false,
      'vehicle-management': true,
      'user-management': true,
      'booking-management': true,
      'driver-assignments': true,
      'promo-codes': true,
      'my-bookings': false,
      'admin-roles': true,
      'kyc-management': true,
      settings: true,
    },
    driver: {
      dashboard: false,
      'vehicle-management': false,
      'user-management': false,
      'booking-management': true,
      'driver-assignments': false,
      'asset-return-details': false,
      'promo-codes': false,
      'my-bookings': true,
      'admin-roles': false,
      'customer-support': false,
      'kyc-management': false,
      settings: false,
    },
    fleet_manager: {
      'vehicle-management': true,
      'user-management': false,
      'booking-management': false,
      'driver-assignments': false,
      'asset-return-details': false,
      'promo-codes': false,
      'my-bookings': false,
      'admin-roles': false,
      'customer-support': false,
      'kyc-management': false,
      settings: false,
    },
    finance_admin: {
      dashboard: true,
      'vehicle-management': false,
      'user-management': false,
      'booking-management': false,
      'driver-assignments': false,
      'asset-return-details': false,
      'promo-codes': false,
      'my-bookings': false,
      'admin-roles': false,
      'customer-support': false,
      'kyc-management': false,
      settings: false,
    },
    customer_support: {
      dashboard: false,
      'vehicle-management': false,
      'user-management': false,
      'booking-management': false,
      'driver-assignments': false,
      'asset-return-details': false,
      'promo-codes': false,
      'my-bookings': false,
      'admin-roles': false,
      'customer-support': true,
      'kyc-management': false,
      settings: false,
    },
  },
};
